import {combineReducers} from "redux"
import {dataReducer} from "./dataReducer"
import {globalReducer} from "./global"
import {userReducer} from "./user"
import {fileReducer} from "./fileReducer"
import {controlReducer} from "./controlReducer"
import {Action, ReducerState} from "./interface/baseInterface"

export const rootReducer = combineReducers({
    global: globalReducer,
    user: userReducer,
    data: dataReducer,
    file: fileReducer,
    control: controlReducer,
})

function crossSliceReducer(state: ReducerState, action: Action) {
    // console.log(action)
    const payload = action.payload
    switch (action.type) {
        case "init":
            return {
                ...state,
                global: globalReducer(state.global, {
                    type: "setServerUrlAndViewTypeAndBillId",
                    payload: payload,
                }),
            }
        case "startComparison":
            if (state.control.activeView === "display" && state.control.comparisonStatus.status === "loading") {
                return {
                    ...state,
                    control: controlReducer(state.control, {
                        type: "startComparisonWithId",
                        payload: payload,
                    }),
                }
            } else {
                return {...state}
            }
        case "queryStatus":
            if (state.control.activeView === "display" && state.control.comparisonStatus.status === "loading") {
                return {
                    ...state,
                    control: controlReducer(state.control, {
                        type: "queryControlStatus",
                        payload: payload,
                    }),
                    data: dataReducer(state.data, {
                        type: "queryDataStatus",
                        payload: payload,
                    }),
                }
            } else {
                return {...state}
            }
        case "getAttachmentList":
            return {
                ...state,
                data: dataReducer(state.data, {
                    type: "changeAttachMent",
                    payload: payload,
                }),
            }
        case "getHistoricalDataList":
            return {
                ...state,
                data: dataReducer(state.data, {type: "setHistoricalDataList", payload: payload}),
            }
        case "returnOperate":
            return {
                ...state,
                control: controlReducer(state.control, {
                    type: "controlInit",
                    payload: "",
                }),
                data: dataReducer(state.data, {
                    type: "dataInit",
                    payload: "",
                }),
            }
        case "tdaBreakOff":
            return {
                ...state,
                control: controlReducer(state.control, {
                    type: "controlInit",
                    payload: "",
                }),
                data: dataReducer(state.data, {
                    type: "dataInit",
                    payload: "",
                }),
            }
        default:
            return state
    }
}

export const reducer = (state: any, action: Action) => {
    const intermediateState = rootReducer(state, action)
    return crossSliceReducer(intermediateState, action)
}
